(function () {
    'use strict';
    var m = angular.module('utils');
    m.factory('path', ["http", "uuid", function (http, uuid) {
        function buildResult(path) {
            return {
                path: path,
                retrieve: function (allowCached) {
                    var req = http.get(path);
                    if (!allowCached) {
                        req.params({ rid: uuid.random() });
                    }
                    return req;
                }
            };
        }
        return function (moduleName) {
            var rootPath = '/assets/' + moduleName;
            var rootPathRelative = 'assets/' + moduleName;
            return {
                directive: function (directiveName) {
                    var directivePath = rootPath + '/directives/' + directiveName;
                    var dirRelPath = rootPathRelative + '/directives/' + directiveName;
                    return {
                        template: function (templateName) {
                            templateName = templateName || directiveName;
                            return directivePath + '/' + templateName + '.html';
                        },
                        img: function (imgName) {
                            return directivePath + '/images/' + imgName;
                        },
                        imgRel: function (imgName) {
                            return dirRelPath + '/images/' + imgName;
                        },
                        json: function (jsonName) {
                            return buildResult(directivePath + '/static/' + jsonName + '.json');
                        },
                        jsonRel: function (jsonName) {
                            return buildResult(dirRelPath + '/static/' + jsonName + '.json');
                        },
                        staticFile: function (staticFileName, useRelativePath) {
                            var root = useRelativePath ? dirRelPath : directivePath;
                            var path = root + '/static/' + staticFileName;
                            return buildResult(path);
                        }
                    };
                },
                ctrl: function (controllerName) {
                    var controllerPath = rootPath + '/controllers/' + controllerName;
                    var controllerPathRel = rootPathRelative + '/controllers/' + controllerName;
                    return {
                        template: function (templateName) {
                            templateName = templateName || controllerName;
                            return controllerPath + '/' + templateName + '.html';
                        },
                        img: function (imgName) {
                            return controllerPath + '/images/' + imgName;
                        },
                        imgRel: function (imgName) {
                            return controllerPathRel + '/images/' + imgName;
                        },
                        json: function (jsonName) {
                            return buildResult(controllerPath + '/static/' + jsonName + '.json');
                        },
                        jsonRel: function (jsonName) {
                            return buildResult(controllerPathRel + '/static/' + jsonName + '.json');
                        },
                        staticFile: function (staticFileName) {
                            return buildResult(controllerPath + '/static/' + staticFileName);
                        }
                    };
                },
                img: function (imgName) {
                    return rootPath + '/images/' + imgName;
                },
                imgRel: function (imgName) {
                    return rootPathRelative + '/images/' + imgName;
                },
                json: function (jsonName) {
                    return buildResult(rootPath + '/static/' + jsonName + '.json');
                },
                staticFile: function (staticFileName) {
                    return buildResult(rootPath + '/static/' + staticFileName);
                },
                staticFileRel: function (staticFileName) {
                    return buildResult(rootPathRelative + '/static/' + staticFileName);
                }
            };
        };
    }]);
}());